module.exports = __webpack_public_path__ + "static/media/as.27f3e372.svg";